// extracted by mini-css-extract-plugin
module.exports = {"root":"Arrow_root__MbDSx","top":"Arrow_top__EWMdM","right":"Arrow_right__SMzjK","bottom":"Arrow_bottom__uPfog","left":"Arrow_left__NHsnL"};